import { gridPageCountSelector, GridPagination, Pagination, useGridApiContext, useGridSelector } from "@bvhi/ui-base";
import { TablePaginationProps } from "@mui/material/TablePagination";

function CustomPagination({ page, onPageChange, className }: Pick<TablePaginationProps, "page" | "onPageChange" | "className">) {
  const apiRef = useGridApiContext();
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <Pagination
      className={className}
      color="primary"
      count={pageCount}
      page={page + 1}
      showFirstButton
      showLastButton
      onChange={(event, newPage) => {
        onPageChange(event as React.MouseEvent<HTMLButtonElement>, newPage - 1);
      }}
    />
  );
}

export const BVHIPagination = () => {
  return <GridPagination ActionsComponent={CustomPagination} />;
};
